var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { column: "", role: "region", "aria-label": "Events content" } },
    [
      _c("v-parallax", {
        attrs: {
          src: "https://gm.goz.fun/wp-content/uploads/2023/03/events-cover.png",
          height: "350",
          role: "img",
          "aria-label": "Events section banner with themed illustration",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        {
          attrs: {
            flat: "",
            role: "region",
            "aria-label": "Events listing content",
          },
        },
        [
          _c(
            "v-layout",
            { attrs: { column: "", "pb-2": "", role: "presentation" } },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg8: "",
                    "justify-center": "",
                  },
                },
                [
                  _c("search", {
                    attrs: {
                      subject: "events",
                      limit: _vm.limit,
                      "aria-label": "Search events",
                    },
                    on: { onChangedText: _vm.onSearchChange },
                  }),
                  _vm._v(" "),
                  _c("posts", {
                    attrs: {
                      posts: _vm.posts,
                      title: _vm.$t("components.events.title"),
                      "is-loading": _vm.isLoading,
                      "aria-label": "Filtered list of events",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }